export const headerData = {
      //Header Defination
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      Authorization: "Basic YWRtaW46MTIzNA==",
      "x-api-key": "neeraj@123",
    }
  

  